<div class="govuk-grid-row">
  <div class="govuk-grid-column-two-thirds">
    <div class="user-profile-container">
      <div class="govuk-breadcrumbs">
        <ol class="govuk-breadcrumbs__list">
          <li class="govuk-breadcrumbs__list-item">
            <a *ngIf="this.isOrgAdmin && userName != ''" class="govuk-breadcrumbs__link" routerLink="/home">
              {{ 'ADMINISTRATOR_DASHBOARD' | translate }}
            </a>
            <a *ngIf="!this.isOrgAdmin && userName != ''" class="govuk-breadcrumbs__link" routerLink="/home">
              {{"PUBLIC_PROCUREMENT_GATEWAY_DASHBOARD" | translate}}
            </a>
            <a *ngIf="userName == ''" class="govuk-breadcrumbs__link" routerLink="/home">
              {{"REGITERATION_HOME" | translate}}
            </a>
          </li>
          <li class="govuk-breadcrumbs__list-item">
            <span class="govuk-breadcrumbs__link">{{"TERMS_OF_USE" | translate}}</span>
          </li>
        </ol>
      </div>
      <div>
        <h1 class="govuk-heading-xl page-title header-bread-align">
          Public Procurement Gateway Terms of Use
        </h1>
        <div class="manage-groups-bg">
          <p class="govuk-body-l">
            This page sets out the Public Procurement Gateway Terms of Use that
            you agree to in order to register, access and use the Public
            Procurement Gateway. These terms were last updated on December 2023.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="govuk-grid-row">
  <div class="govuk-grid-column-one-third">
    <h2 class="govuk-heading-m">Browse by category</h2>
    <div class="browse-list">
      <ul class="no-bullets">
        <li>
          <a class="navigation-text"  onclick="return false;"
            (click)="scrollContent('Definitions')">Definitions</a>
        </li>
        <li> 
          <a class="navigation-text"  onclick="return false;" (click)="scrollContent('UsingPPG')">1. Using the
            Public Procurement Gateway (PPG)</a>
        </li>
        <li>
          <a class="navigation-text"  onclick="return false;" (click)="scrollContent('Amending')">2. Amending the
            Terms of Use</a>
        </li>
        <li>
          <a class="navigation-text"  onclick="return false;"
            (click)="scrollContent('PPGUserAdministrator')">3. PPG User Administrator</a>
        </li>
        <li>
          <a class="navigation-text"  onclick="return false;"
            (click)="scrollContent('TwoFactorAuthentication')">4. Two Factor Authentication</a>
        </li>
        <li>
          <a class="navigation-text"  onclick="return false;"
            (click)="scrollContent('UsersaccessingthePPG')">5. Users accessing the PPG</a>
        </li>
        <li>
          <a class="navigation-text"  onclick="return false;"
            (click)="scrollContent('Obligations')">6. Organisation and User/s Obligations, Warranties and Liabilities</a>
        </li>
        <li>
          <a class="navigation-text"  onclick="return false;"
            (click)="scrollContent('ExternallinkingtoPPG')">7. External linking to PPG</a>
        </li>
        <li>
          <a class="navigation-text"  onclick="return false;"
            (click)="scrollContent('ExternalLinkingfromPPG')">8. External Linking from PPG</a>
        </li>
        <li>
          <a class="navigation-text"  onclick="return false;" (click)="scrollContent('UsingPPGContent')">9. Using
            PPG Content</a>
        </li>
        <li>
          <a class="navigation-text"  onclick="return false;"
            (click)="scrollContent('Limitsonliability')">10. Limits on liability</a>
        </li>
        <li>
          <a class="navigation-text"  onclick="return false;"
            (click)="scrollContent('Requeststoremovecontent')">11. Requests to remove content</a>
        </li>
        <li>
          <a class="navigation-text"  onclick="return false;" (click)="scrollContent('CookiePolicy')">12. Cookie
            Policy</a>
        </li>
        <li>
          <a class="navigation-text"  onclick="return false;"
            (click)="scrollContent('IntellectualPropertyRights')">13. Intellectual Property Rights</a>
        </li>
        <li>
          <a class="navigation-text"  onclick="return false;" (click)="scrollContent('DataProtection')">14. Data
            Protection</a>
        </li>
        <li>
          <a class="navigation-text"  onclick="return false;"
            (click)="scrollContent('RightsofThirdParties')">15. Rights of Third Parties</a>
        </li>
        <li>
          <a class="navigation-text"  onclick="return false;" (click)="scrollContent('LawandJurisdiction')">16. Law
            and Jurisdiction</a>
        </li>
      </ul>
    </div>
  </div>
  <div class="govuk-grid-column-two-thirds">
    <div id="Definitions" class="Definitions">
      <h2 class="govuk-heading-m">Definitions:</h2>
      <p class="govuk-body govuk-!-font-size-19">
        The following definitions shall have the following meanings:
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        <strong>“Administrator”</strong> means the administrator of an
        Organisation’s PPG Accounts.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        <strong>“GCA”</strong>
        means the Minister for the Cabinet Office as represented by Government
        Commercial Agency, a trading fund of the Cabinet Office whose offices
        are located at 9th Floor, The Capital, Old Hall Street, Liverpool LS
        9PP.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        <strong>“Controller”</strong> has the meaning given under UK GDPR.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        <strong>“Force Majeure”</strong>
      </p>
      <span>
        <p class="govuk-body govuk-!-font-size-19">
          any event, circumstance, matter or cause affecting the performance by
          GCA of its obligations including, without limitation:
        </p>
        <ol>
          <li class="govuk-body govuk-!-font-size-19">
            (a)&nbsp; &nbsp;acts, events, omissions, happenings or
            non-happenings beyond its reasonable control which prevent or
            materially delay GCA from performing its obligations;
          </li>
          <li class="govuk-body govuk-!-font-size-19">
            (b)&nbsp; &nbsp;riots, civil commotion, war or armed conflict, acts
            of terrorism, nuclear, biological or chemical warfare;
          </li>
          <li class="govuk-body govuk-!-font-size-19">
            (c)&nbsp; &nbsp;acts of a Crown Body, local government or regulatory
            bodies
          </li>
          <li class="govuk-body govuk-!-font-size-19">
            (d)&nbsp; &nbsp;fire, flood or any disaster;
          </li>
          <li class="govuk-body govuk-!-font-size-19">
            (e)&nbsp; &nbsp;an industrial dispute affecting a third party for
            which a substitute third party is not reasonably available;
          </li>
          <li class="govuk-body govuk-!-font-size-19">
            (f)&nbsp; &nbsp;epidemic or pandemic;
          </li>
        </ol>
        <p class="govuk-body govuk-!-font-size-19">
          and which is not attributable to any wilful act, neglect or failure to
          take reasonable preventative action by GCA.
        </p>
      </span>
      <span>
        <p class="govuk-body govuk-!-font-size-19">
          <strong>“Intellectual Property Rights”</strong> means
        </p>
        <ol>
          <li class="govuk-body govuk-!-font-size-19">
            (a)&nbsp; &nbsp;copyright, rights related to or affording protection
            similar to copyright, rights in databases, patents and rights in
            inventions, semi-conductor topography rights, trade marks, rights in
            get up, rights in internet domain names and website addresses and
            other rights in trade or business names, goodwill, designs,
            Know-How, trade secrets and other rights in Confidential Information
            and all other intellectual property rights, in each case whether
            registered or unregistered; and
          </li>
          <li class="govuk-body govuk-!-font-size-19">
            (b)&nbsp; &nbsp;applications for registration, and the right to
            apply for registration, for any of the rights listed at (a) that are
            capable of being registered in any country or jurisdiction; and
          </li>
          <li class="govuk-body govuk-!-font-size-19">
            (c)&nbsp; &nbsp;all other rights having equivalent or similar effect
            in any country or jurisdiction.
          </li>
        </ol>
        <p class="govuk-body govuk-!strong-font-size-19">
          <strong>“Organisation” </strong>means an organisation registered to
          use the PPG and responsible for its Users’ activities on the PPG.
        </p>
        <p class="govuk-body govuk-!-font-size-19">
          <strong>“Personal Data”</strong> has the meaning given to it in UK
          GDPR.
        </p>
        <p class="govuk-body govuk-!-font-size-19">
          <strong>“PPG Account/s”</strong> means the account(s) used by
          individual User/s on behalf of their Organisation to access the PPG.
        </p>
        <p class="govuk-body govuk-!-font-size-19">
          <strong> “Privacy Policy”</strong> means GCA’s Privacy Notice which is
          available here:
          <a target="_blank" class="navigation-text privacy-link"
            href="https://www.gov.uk/government/publications/crown-commercial-service-privacy-notice/crown-commercial-service-privacy-notice">https://www.gov.uk/government/publications/crown-commercial-service-privacy-notice/crown-commercial-service-privacy-notice</a>
        </p>
        <p class="govuk-body govuk-!-font-size-19">
          <strong>“Public Procurement Gateway”</strong> and
          <strong>“PPG”</strong>means this service platform which provides the
          single point of entry for organisations to access multiple GCA service
          platforms.
        </p>
        <p class="govuk-body govuk-!-font-size-19">
          <strong>“Two Factor Authentication”</strong> means the system by which 
          two distinct forms of identification are required in order to access the PPG. 
          The Two Factor Authentication for a PPG Account is the User entering their 
          login information and entering a unique time limited code, which is generated 
          and delivered to the User either by text message to their mobile phone or in 
          an app that they access using their mobile phone, each time they enter their 
          login information to access the PPG.
        </p>
        <p class="govuk-body govuk-!-font-size-19">
          <strong>“UK GDPR”</strong>means Regulation (EU) 2016/679 of the
          European Parliament and of the Council of 27 April 2016 on the
          protection of natural persons with regard to the processing of
          personal data and on the free movement of such data (United Kingdom
          General Data Protection Regulation), as it forms part of the law of
          England and Wales, Scotland and Northern Ireland by virtue of section
          3 of the European Union (Withdrawal) Act 2018, together with the Data
          Protection, Privacy and Electronic Communications (Amendments etc.)
          (EU Exit) Regulations 2019.
        </p>
        <p class="govuk-body govuk-!-font-size-19">
          <strong>“User/s”</strong> means an individual, or more than one
          individual from an Organisation.
        </p>
        <p class="govuk-body govuk-!-font-size-19">
          <strong>“You/r”</strong> refers to a User/s and/or their organisation
          and is used here synonymously with the term “User/s”.
        </p>
        <p class="govuk-body govuk-!-font-size-19">
          <strong>“We”</strong>means GCA and is used here synonymously with GCA.
        </p>
        <p class="govuk-body govuk-!-font-size-19">
          <strong>“Working Days”</strong>means 0900hrs - 1700hrs Monday to
          Friday in the United Kingdom excluding Bank Holidays.
        </p>

        <p class="govuk-body govuk-!-font-size-19">
          <strong>Interpretation:</strong>
        </p>
        <p class="govuk-body govuk-!-font-size-19">
          The headings to clauses are inserted for convenience only and shall
          not affect the interpretation or construction of these Terms of Use.
        </p>
        <p class="govuk-body govuk-!-font-size-19">
          Unless the context otherwise requires, words imparting the singular
          shall include the plural and vice versa. Unless the context otherwise
          requires words imparting a gender include every gender and references
          to persons include an individual, company, corporation, firm or
          partnership.
        </p>
        <p class="govuk-body govuk-!-font-size-19">
          References to any statute or statutory provision shall include (i) any
          subordinate legislation made under it, (ii) any provision which it has
          modified or re-enacted (whether with or without modification), and
          (iii) any provision which subsequently supersedes it or re-enacts it
          (whether with or without modification).
        </p>
        <p class="govuk-body govuk-!-font-size-19">
          Any obligation on a party not to do something includes an obligation
          not to allow that thing to be done.
        </p>
      </span>
    </div>
    <div id="UsingPPG" class="UsingPPG">
      <h2 class="govuk-heading-m">1. Using the Public Procurement Gateway (PPG)</h2>  
      <p class="govuk-body govuk-!-font-size-19">
       1.1 These Terms of Use govern the registration, access and use of the PPG.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        1.2 By using the PPG an Organisation and its User/s confirm agreement to
        comply with these Terms of Use and any guidance issued by GCA in
        relation to use of the PPG.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        1.3 Whilst GCA manages the PPG, User/s should note that some of the service
        platforms accessed through the PPG are owned and operated by other
        government departments or agencies.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        1.4 The Organisation and its User/s acknowledge and accept that:
      </p>
      <ul class="no-bullets shared-font" style="margin-left: 45px;">        
          <li>
            1.4.1 GCA reserves the right to interrupt, suspend or remove the
            availability of the PPG and/or revoke access at any time without
            incurring any liability; and
          </li>
        </ul>
      <ul class="no-bullets shared-font" style="margin-left: 45px;"> 
          <li>
            1.4.2 GCA provides the PPG on an ‘as is’ basis and ‘as available’ basis.
          </li>       
      </ul>
    </div>
    <div id="Amending" class="Amending">
      <h2 class="govuk-heading-m">2. Amending the Terms of Use</h2>
      <p class="govuk-body govuk-!-font-size-19">
        2.1 GCA reserves the right to update these Terms of Use at any time. GCA
        will notify all users of the PPG that the Terms of Use have been updated
        by a notification banner on the PPG homepage.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        2.2 An Organisation and its User/s confirm their acceptance of the updated
        Terms of Use by their continued use of the PPG
      </p>
    </div>
    <div id="PPGUserAdministrator" class="PPGUserAdministrator">
      <h2 class="govuk-heading-m">3. PPG User Administrator</h2>
      <p class="govuk-body govuk-!-font-size-19">
        3.1 When registering on the PPG an Organisation must designate one
        individual User as the Organisation’s Administrator.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        3.2 The Administrator is responsible for managing their Organisation’s PPG
        Account, including appointing other Users as Administrators.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        3.3 Administrators, as Controllers of their Organisation's data, are
        responsible for the management of their Organisation’s PPG Accounts.
        When a registered User/s leaves an Organisation, the Administrator must
        disable their account. The Administrator must also submit a request in
        writing for GCA to disable the User/s account.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        3.4 Login and password are strictly personal to the User/s and are
        non-transferable. Each User/s shall ensure they do not divulge or
        disclose their password to third -7-parties. In the event that a User/s
        becomes aware a password may have been divulged, disclosed or discovered
        by any third party, they shall contact their Administrator who shall
        take immediate action to rectify the situation.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        3.5 In the event that employees of an Organisation not already registered as Users contact GCA to request the
        details of the Organisation’s Administrator(s), GCA will disclose the name and email address of the
        Organisation’s Administrator(s). This is to enable registration queries to be addressed by the Organisation’s
        Administrator. By registering as the Administrator for an Organisation, a User acknowledges that its name and
        email address may be shared with other individuals within the same Organisation.
      </p>
    </div>
    <div id="TwoFactorAuthentication" class="TwoFactorAuthentication">
      <h2 class="govuk-heading-m">4. Two Factor Authentication</h2>
      <p class="govuk-body govuk-!-font-size-19">
        4.1 When setting up their PPG Account the Organisation’s Administrator must determine whether 
        to require their Users to utilise Two Factor Authentication when accessing their PPG Accounts 
        and set these preferences on the PPG Account accordingly. The default setting for Two Factor Authentication 
        is for it to be enabled.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        4.2 The Organisation’s Administrators may change the Two Factor Authentication preferences 
        for all of the Organisation’s Users at any time. 
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        4.3 If the Organisation’s Administrator has set Two Factor Authentication as optional for 
        their PPG Accounts, then the User is able to decide whether to enable the Two Factor Authentication 
        requirement for their PPG Account, and the User can change their Two Factor Authentication setting 
        on their PPG Account at any time.
      </p>
    </div>
    <div id="UsersaccessingthePPG" class="UsersaccessingthePPG">
      <h2 class="govuk-heading-m">5. Users accessing the PPG</h2>
      <p class="govuk-body govuk-!-font-size-19">
        5.1 User/s must use their Organisation’s email address to access the PPG. A
        User may access the PPG using personal email accounts such as Hotmail,
        Gmail, Google Mail if that is the email that the Organisation utilises
        for its normal operations.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        5.2 GCA in its absolute discretion reserves the right to suspend,
        deactivate, change, vary, limit or remove a User/’s access to PPG if the
        Organisation and/or its User/s commits a material breach of any of its
        obligations under these Terms of Use (after having been notified to
        remedy or desist such breach within a period of ten (10) Working Days
        and failing to do so).
      </p>
    </div>
    <div id="Obligations" class="Obligations">
      <h2 class="govuk-heading-m">6. Organisation and User/s Obligations, Warranties and
        Liabilities</h2>
      <p class="govuk-body govuk-!-font-size-19">
        6.1 The Organisation and its User/s shall use PPG for lawful and proper
        purposes only and shall, in any event, comply with all relevant laws,
        regulations and codes of practice within the UK or other jurisdictions
        from which User/s access PPG, including the Public Contracts Regulations
        2015 (and any replacement of such regulations).
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        6.2 GCA shall report any attacks or attempts to gain unauthorised access to
        PPG to the relevant law enforcement authorities and will share
        information about the Organisation and/or its User/s with them.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        6.3 The Organisation and its User/s must ensure that the way in which it
        uses the PPG does not expose the Organisation and/or its User/s to the
        risk of viruses, malicious computer code or other forms of interference,
        which damage IT systems.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        6.4 The Organisation and its User/s shall:
      </p>
      <ul>
        <li>use PPG only for lawful purposes;</li>
        <li>
          use PGG in a way that doesn’t infringe the rights of, or restrict or
          inhibit the use and enjoyment of this site by any other party;
        </li>
        <li>
          ensure that all information uploaded to the PPG is current, secure,
          accurate, complete and free from viruses;
        </li>
        <li>
          ensure they comply with these Terms of Use (as updated from time to
          time on PPG in accordance with Clause 2) and any additional terms
          notified via PPG;
        </li>
        <li>
          use all reasonable care and skill in performing obligations under
          these Terms of Use;
        </li>
        <li>
          provide the equipment and software needed to access and use the PPG;
        </li>
        <li>
          use best endeavours to protect PPG from viruses when being accessed
          and used;
        </li>
        <li>
          not introduce viruses, trojans, worms, logic bombs or any other
          material that is malicious or technologically harmful;
        </li>
        <li>
          be responsible for any unauthorised, false or fraudulent information
          that is submitted by any of its User/s.
        </li>
      </ul>
      <p class="govuk-body govuk-!-font-size-19">
        6.5 The Organisation and its User/s shall not:
      </p>
      <ul>
        <li>
          manipulate any information supplied on PPG in a manner that would lead
          to inaccurate, misleading or discriminating presentation of
          information being displayed;
        </li>
        <li>
          post, transmit or disseminate any information on or via PPG which is
          or may be harmful, obscene, defamatory or otherwise illegal;
        </li>
        <li>
          seek unauthorised access to the PPG, the server on which it is stored
          or any server, computer or database connected to it;
        </li>
        <li>
          use PPG in a manner which causes or may cause an infringement of the
          rights of any other; or
        </li>
        <li>
          use any software, routine or device to interfere or attempt to
          interfere electronically or manually with the operation or
          functionality of PPG, including uploading or making available files
          containing corrupt data or viruses via whatever means.
        </li>
      </ul>
      <p class="govuk-body govuk-!-font-size-19">
        6.6 The Organisation represents and warrants that the information it
        provides when using the PPG will be as accurate, up to date, secure, as
        complete as possible and free from bugs or viruses.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        6.7 The Organisation shall indemnify GCA in full against all claims,
        demands, actions or proceedings (including legal and other professional
        advisers fees) made by any third party arising out of or in relation to
        breach of its or its User/s obligations under these Terms of Use.
      </p>
    </div>
    <div id="ExternallinkingtoPPG" class="ExternallinkingtoPPG">
      <h2 class="govuk-heading-m">7. External linking to PPG</h2>
      <p class="govuk-body govuk-!-font-size-19">
        7.1 GCA welcomes and encourages other websites to link to the PPG.
        Administrators must contact GCA for permission at
        <a class="navigation-text" href="mailto:info@gca.gov.uk">info&#64;gca.gov.uk
        </a>
        to request that the Organisation’s website is associated with or
        endorsed by GCA or another government department or agency.
      </p>
      <p>
        7.2 GCA reserves the right to withdraw linking permission without notice.
      </p>
      <p>
        7.3 GCA specifically will not allow user third party websites to do the
        following:
      </p>
      <ul class="no-bullets shared-font" style="margin-left: 45px;">
        <li>7.3.1 charge for any links to any page on the PPG website.</li>
      </ul>
      <ul class="no-bullets shared-font" style="margin-left: 45px;">
        <li>
          7.3.2 state on your website that it is associated with or endorsed by GCA,
          or another government department or agency.
        </li>
      </ul>
    </div>
    <div id="ExternalLinkingfromPPG" class="ExternalLinkingfromPPG">
      <h2 class="govuk-heading-m">8. External Linking from PPG</h2>
      <p class="govuk-body govuk-!-font-size-19">
        8.1 PPG contains links to external websites managed by other government
        departments and agencies, service providers or other organisations. For
        the avoidance of doubt, GCA do not have any control over the content on
        these websites.
      </p>
      <p class="govuk-body govuk-!-font-size-19">8.2 GCA is not responsible for:</p>
      <ul class="no-bullets shared-font" style="margin-left: 45px;">
        <li>
          8.2.1 the protection of any information the Organisation and its User/s give
          to external websites; and/or
        </li></ul>
        <ul class="no-bullets shared-font" style="margin-left: 45px;">
        <li>
          8.2.2 any loss or damage that may come from use of these websites, or any
          other websites they link to or cookie policies.
        </li>
      </ul>
      <p class="govuk-body govuk-!-font-size-19">
       8.3 GCA does not accept any liability relating to any claim or disputes
        arising out of the Organisation and its User/s use of any external
        websites.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        8.4 It is the Organisation and its User/s ’responsibility to comply with any
        relevant terms and conditions, terms of use, privacy policies, cookie
        policies and end user licences that relate to external websites
      </p>
    </div>
    <div id="UsingPPGContent" class="UsingPPGContent">
      <h2 class="govuk-heading-m">9. Using PPG Content</h2>
      <p>
        9.1 Most content on the PPG is subject to
        <a target="_blank" class="navigation-text"
          href="https://www.nationalarchives.gov.uk/information-management/re-using-public-sector-information/uk-government-licensing-framework/crown-copyright/">Crown
          copyright protection</a> and is published under the <a target="_blank" class="navigation-text"
          href="https://www.nationalarchives.gov.uk/doc/open-government-licence/version/1/open-government-licence.htm">Open Government Licence</a> (OGL).
      </p>
      <p>
        9.2 Some content is exempt from the OGL - check the
        <a target="_blank" class="navigation-text"
          href="https://www.nationalarchives.gov.uk/doc/open-government-licence/version/1/open-government-licence.htm">
          list of exemptions</a>.
      </p>
      <p>
        9.3 Departmental logos and crests are also exempt from the OGL, except
        when they form an integral part of a document or dataset.
      </p>
      <p>
        9.4 If any content is not subject to Crown copyright protection or
        published under the OGL, if applicable GCA will credit the author or
        copyright holder.
      </p>
      <p>
        9.5 Organisations can reproduce content published on the PPG under the OGL
        as long as it follows the licence’s conditions. Further guidance on
        this can be found at <a target="_blank" class="navigation-text"
          href="https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/">
          Open Government Licence (nationalarchives.gov.uk).</a>
      </p>
    </div>
    <div id="Limitsonliability" class="Limitsonliability">
      <h2 class="govuk-heading-m">10. Limits on liability</h2>
      <p class="govuk-body govuk-!-font-size-19">
        10.1 While GCA make every effort to keep PPG up to date and secure, it does
        not provide any guarantees, conditions or warranties that the
        information will be accurate, up to date, secure, complete or free from
        bugs or viruses.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        10.2 GCA is not liable for any loss or damage that may come from using the
        PPG including if the loss or damage was foreseeable, arose in the normal
        course of things or the Administrator advised GCA that it might happen.
        This includes but is not limited to
      </p>
      <ul class="no-bullets shared-font" style="margin-left: 45px;">
        <li>10.2.1 any direct, indirect or consequential losses;</li>
      </ul>
      <ul class="no-bullets shared-font" style="margin-left: 45px;">
        <li>
          10.2.2 loss of profits, turnover, savings, business opportunities or damage
          to goodwill (in each case whether direct or indirect);
        </li>
      </ul>
      <ul class="no-bullets shared-font" style="margin-left: 45px;">
        <li>
          10.2.3 any loss, disruption or damage to your data or computer through the
          use of the PPG and any websites that are linked to or from it; or
        </li>
      </ul>
      <ul class="no-bullets shared-font" style="margin-left: 45px;">
        <li>
          10.2.4 any loss related to the inability to use the PPG and any websites that
          are linked to or from it.
        </li>
      </ul>
      <p class="govuk-body govuk-!-font-size-19">
        10.3 GCA is not liable to any Organisation and its User/s /s for any loss or
        damages arising from the use of the PPG caused by
      </p>
      <ul class="no-bullets shared-font" style="margin-left: 45px;">
        <li>
          10.3.1 An event of Force Majeure that affects the availability and/or
          performance of the PPG;
        </li></ul>
        <ul class="no-bullets shared-font" style="margin-left: 45px;">
        <li>10.3.2 Incorrect use by the Organisation and its User/s of the PPG;</li></ul>
        <ul class="no-bullets shared-font" style="margin-left: 45px;">
        <li>
          10.3.3 Connectivity failures in respect of the equipment used by the
          Organisation and its User/s;
        </li></ul>
        <ul class="no-bullets shared-font" style="margin-left: 45px;">
        <li>10.3.4 Breakdown of the PPG.</li>
      </ul>
      <p>
        10.4 Nothing in these Terms of Use shall be construed so as to exclude or
        limit liability for death or personal injury or for fraud or fraudulent
        misrepresentation or for any other liability which it would not be
        lawful to so exclude or limit
      </p>
      <p>
        10.5 Subject to 10.4, in no event shall GCA be liable to any User/s for any
        sum greater than 100 (one hundred) GBP in aggregate under the provisions of these
        Terms of Use.
      </p>
    </div>
    <div id="Requeststoremovecontent" class="Requeststoremovecontent">
      <h2 class="govuk-heading-m">11. Requests to remove content</h2>
      <p class="govuk-body govuk-!-font-size-19">
        11.1 The Administrator can request for content or Personal Data to be removed
        or amended from PPG. To make a request the Administrator must send to
        GCA the web address (URL) of the content and explain why it should be
        amended or removed.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        11.2 GCA will consider any requests in compliance with UK GDPR and any
        decision will be at GCA’s sole discretion. Such a decision will be
        communicated to the Administrator.
      </p>
    </div>
    <div id="CookiePolicy" class="CookiePolicy">
      <h2 class="govuk-heading-m">12. Cookie Policy</h2>
      <p class="govuk-body govuk-!-font-size-19">
        12.1 The
        <a target="_blank" class="navigation-text" href="https://identify.gca.gov.uk/cookies">PPG has a
          Cookie Policy</a> which can be accessed from the PPG home page. The Organisation and its
        User/s will have the option for PPG to collect information and confirm
        that any data provided is accurate in accordance with the Cookie Policy.
      </p>
    </div>
    <div id="IntellectualPropertyRights" class="IntellectualPropertyRights">
      <h2 class="govuk-heading-m">13. Intellectual Property Rights</h2>
      <p class="govuk-body govuk-!-font-size-19">
        13.1 All Intellectual Property Rights in PPG are owned by GCA.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        13.2 The Organisation and its User/s shall have no Intellectual Property
        Rights in PPG nor shall the Organisation and its User/s have any rights
        to copy, adapt, modify or interfere with PPG.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        13.3 PPG may include GCA logo/s and or trade marks. An Organisation and its
        User/s acknowledges that it may not copy or make other use of such logos
        and/or trademarks.
      </p>
    </div>
    <div id="DataProtection" class="DataProtection">
      <h2 class="govuk-heading-m">14. Data Protection</h2>
      <p class="govuk-body govuk-!-font-size-19">14.1 The Organisation and its User/s shall comply with UK GDPR and all
        relevant regulations together with any codes of conduct and guidance
        issued by the Information Commissioner from time to time and they shall
        not do or cause or permit to be done anything which may cause or
        otherwise result in a breach by GCA.</p>
      <p class="govuk-body govuk-!-font-size-19">14.2 GCA will collect, hold and process Personal Data obtained from and
        about
        User/s. GCA will only store Personal Data to the extent necessary for
        the purposes for which the Personal Data is being processed.</p>
      <p class="govuk-body govuk-!-font-size-19">14.3 It is the Organisation and its User/s’ responsibility to ensure they
        comply with all relevant law including UK GDPR in relation to their data
        processing activities.</p>
      <p class="govuk-body govuk-!-font-size-19">14.4 The Organisation shall indemnify GCA against any and all losses
        incurred
        if the Organisation or its User/s breaches any UK GDPR.</p>
      <p class="govuk-body govuk-!-font-size-19">14.5 The Organisation (and if applicable its User/s) shall procure the
        agreement of each relevant data subject to such data being collected,
        held and used in accordance with these Terms of Use, any relevant
        Privacy Policies, the Data Protection Legislation and relevant Cookie
        Policies.</p>
      <p class="govuk-body govuk-!-font-size-19">14.6 GCA’s data retention policy for the PPG is to retain the information
        uploaded into the PPG for a maximum of seven years.</p>
    </div>
    <div id="RightsofThirdParties" class="RightsofThirdParties">
      <h2 class="govuk-heading-m">15. Rights of Third Parties</h2>
      <p class="govuk-body govuk-!-font-size-19">
        15.1 No third parties may use the Contracts (Rights of Third Parties) Act
        (CRTPA) to enforce any term of the Contract unless stated (referring to
        CRTPA) in the Contract. This does not affect third party rights and
        remedies that exist independently from CRTPA/s.
      </p>
    </div>
    <div id="LawandJurisdiction" class="LawandJurisdiction">
      <h2 class="govuk-heading-m">16. Law and Jurisdiction</h2>
      <p class="govuk-body govuk-!-font-size-19">
        16.1 These Terms of Use and any dispute or claim arising out of or in
        connection with it or its subject matter or formation (including
        non-contractual disputes or claims) shall be governed by and construed
        in accordance with the law of England and Wales.
      </p>
      <p class="govuk-body govuk-!-font-size-19">
        16.2 Each party irrevocably agrees that the courts of England and Wales shall
        have exclusive jurisdiction to settle any dispute or claim arising out
        of or in connection with these Terms of Use or its subject matter or
        formation (including non-contractual disputes or claims).
      </p>
    </div>
  </div>
</div>
